import React ,{createRef }from "react";
import { browserHistory } from "react-router";
import { formatName, formatType, capitalizeAll, addSpaceAfterComma, formatNumber, formatAddress, formatNames, getTenantSubcategoryOptions, pruneTenantSubcategories, sanitizeNotesForInput } from "../../utils";
import { dateISOtoUS, dateUStoISO, dateToString } from "../../date-converter";
import { sendBuyerEmail, sendEmailNotification } from "../../requests/emailRequests";
import { priceToString } from "../CRUDProperty/CRUDProperty";
import { url } from "../../consts/env";
import { ApolloConsumer } from "@apollo/client";
import { GET_BUYERS, GET_BUYERS_BY_ID, GET_TEAM } from "../Graphql/Queries/BuyersQuery";
import { CREATE_BUYERS } from "../Graphql/Mutations/BuyersMutation";
import { fetchData, mutateData } from "../Service/graphQlService";
import { CREATE_OR_UPDATE_CONTACTS_BUYERS, CREATE_OR_UPDATE_CONTACTS_INVESTORS } from "../Graphql/ContactsMutations/allContactsMutation";
import { GET_BUYER_LIST_QUERY, GET_CONTACT_BUYER_BY_ID, GET_CONTACT_INVESTOR_BY_ID, GET_CONTACT_TEAM_BY_ID, GET_CONTACT_TEAM_LIST_QUERY, GET_INVESTOR_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import CRUD from "../CRUD/CRUD";
import { resolveInvestorStatus, DEFAULT_INVESTOR_STATUS, STATUS_1031_BUYER, STATUS_ACTIVE_INVESTOR } from "../../investor-status";
import InvestorInfo from "./InvestorInfo";
import InvestorCompanyInfo from "./InvestorCompanyInfo";
import PropertyDrawer from "../PropertyDrawer/PropertyDrawer";
import Drawer from "../Drawer";
import { GET_PROPERTIES } from "../Graphql/Queries/propertiesQuery";
import PropertyInfo from "../CRUDProperty/components/PropertyInfo";
import { UserContext } from "../Root/Root";
import NotesReusable from "../NotesReusable";
import InvestorPropertiesTab from "./InvestorPropertiesTab";
import PeopleGroupsTab from "../PeopleGroupsTab";
import unitedStates from "united-states";

//thios ui is refrenced by earlier Buyer screen hence used same class names
const limit = 100000;

// Company records may store the state as a full name ("Texas") while the
// STATE dropdown persists the abbreviation ("TX") - normalize to the abbr.
function stateToAbbr(state) {
    if (!state) return "";
    const value = String(state).trim();
    const match = unitedStates.find(
        (el) =>
            el.abbr.toLowerCase() === value.toLowerCase() ||
            el.name.toLowerCase() === value.toLowerCase()
    );
    return match ? match.abbr : value;
}

const priceProps = [
    "price_min",
    "price_max",
];

// date_of_down_leg is intentionally not converted to US format: it feeds a
// native <input type="date">, which requires YYYY-MM-DD.
const dateProps = [
    "last_modified",
];


function parseNumber(data, property) {
    const value = data[property]
    return Number(
      typeof value === "string" ? value.replace(/,/g, "") : value || 0
    );
  }


function convertDataToForm(dbData) {
    const data = { ...dbData };

    priceProps
        .filter((key) => data[key])
        .forEach((key) => {
            const num = Number(data[key]);
            if (num === num) {
                // !isNaN
                data[key] = num.toLocaleString();
            }
        });

    dateProps
        .filter(key => data[key])
        .forEach(key => {
            const str = dateISOtoUS(data[key]);
            if (str !== false)
                data[key] = str;
        });

    return data;
}
const propertyPriceProps = [
    'LIST_PRICE',
    'HSC_PRICE'
  ];
function convertFormToData(formData) {
    const data = { ...formData };

    priceProps.forEach((key) => {
        const num = priceToString(data[key]);
        if (num !== false)
            data[key] = num;
    });

    dateProps
        .filter(key => data[key])
        .forEach(key => {
            const str = dateUStoISO(data[key]);
            if (str !== false)
                data[key] = str;
        });

    return data;
}
function convertFormToOffMarketData(formData) {
  const data = {...formData};

  dateProps
      .filter(key => data[key])
      .forEach(key => {
          const str = dateUStoISO(data[key]);
          if (str !== false)
              data[key] = str;
      });

  propertyPriceProps.forEach((key) => {
          const num = priceToString(data[key]);
          if (num !== false)
              data[key] = num;
      });      


  return data;
}
function convertPropertyDataToForm(dbData) {
  const data = {...dbData};

  propertyPriceProps
    .filter((key) => data[key])
    .forEach((key) => {
        const num = Number(data[key]);
        if (num === num) {
            data[key] = formatNumber(num,true);
        }
    }); 

  return data;
}
export default class CRUDInvestor extends React.Component {
  drawerComponentRef;
  static get contextType() {
      return UserContext;
    }
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      isExists: false,
      users: [],
      error: null,
      success: null,
      errorTabs: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
      previousStatus: null,
      showDrawer: false,
      offMarketProperty: null,
      searchCrudFilter: false,
      filterData: [],
      currentIndex: 0,
      fromListUrl: props.location.state && props.location.state.fromListUrl || localStorage.getItem('fromListUrl') || null,
      loggedInUserData:{},
      typeDuplicate: null,
    };
    this.client = null;
    this.notesRef = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.saveData = this.saveData.bind(this);
    this.savedNewItem = this.savedNewItem.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.drawerComponentRef = React.createRef();
    this.updateURL = this.updateURL.bind(this);
    this.handleNotesChange = this.handleNotesChange.bind(this)
  }
  savedNewItem(newData) {
    const state = {
      offMarketProperty: { ...newData },
    };
    this.setState(state, () => this.toggleDrawer());
    this.fetch(this.props.params.id);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {
    const userData = this.context.userData;
    this.setState({loggedInUserData: userData});
    if (this.state.fromListUrl) {
      localStorage.setItem('fromListUrl', this.state.fromListUrl);
      this.setState({ fromListUrl: this.state.fromListUrl });
    }
    //#region Below code executes when we click the Last name in MergeDuplicate screen
    const tabParam = this.props.location.query && this.props.location.query.tab;
    if (tabParam && !isNaN(tabParam)) {
      this.setState({ currentTab: parseInt(tabParam.trim(), 10) });
    }
    else {
      this.setState({ currentTab: 0 });
    }
    const queryParams = new URLSearchParams(this.props.location.search);
    queryParams.delete("tab");
    //#endregion
   
    const hasQuery = queryParams.toString().length > 0;
    if (!hasQuery) {      
      this.fetch(this.props.params.id);
    }
    if (hasQuery && !tabParam) {
      this.setState({ searchCrudFilter: true });
      this.handleQueryChange();
    }
  }

  parseFilterOptions(query) {
    const filterObject = {};
    if (query) {
      for (const key in query) {
        if (key !== "order" && key !== "page") {
          filterObject[key] = query[key];
        }
      }
    }
    return [filterObject];
  }
  componentDidUpdate(prevProps) {
    const hasQuery =
      new URLSearchParams(this.props.location.search).toString().length > 0;
    const prevHasQuery =
      new URLSearchParams(prevProps.location.search).toString().length > 0;
    if (hasQuery && prevProps.location.search !== this.props.location.search) {
      this.handleQueryChange();
      this.setState({ searchCrudFilter: true });
    }
    // Check if the query has changed
    // if (prevProps.location.search !== this.props.location.search) {
    //   this.handleQueryChange();
    // }
    if (!hasQuery && prevHasQuery) {
      this.fetch(this.props.params.id);
      this.setState({ searchCrudFilter: false });
    }
  }

  handleQueryChange() {
    const query = this.props.location.query;
    const filterOptions = this.parseFilterOptions(query);

    var isNoFilter = Object.keys(filterOptions).length === 0;

    if (isNoFilter) {
      this.fetch(this.props.params.id);
    } else {
      this.fetchWithFilter(filterOptions);
    }
  }

handleNotesChange(updatedNotes, editId) {
  const cleanedNotes = updatedNotes
    .filter((note) => note.text && note.text.trim() !== "")
    .filter((note) => {
      // Case 1: new note (no arcimedes_row_id)
      if (!note.arcimedes_row_id) return true;

      // Case 2: edited note (arcimedes_row_id matches editId)
      if (editId && note.arcimedes_row_id === editId) return true;

      // Case 3: deleted note
      if (note.deleted === 1) return true;

      // Skip everything else
      return false;
    })
    .map(
      ({
        __typename,
        arcimedes_created,
        arcimedes_modified,
        arcimedes_created_by,
        arcimedes_modified_by,
        temp_id,
         date,
        ...rest
      }) => rest
    );

  this.setState((prev) => ({
    data: {
      ...prev.data,
      notes: cleanedNotes,
    },
  }));
}





  fetchWithFilter(filterOptions) {
    this.setState({
      data: null,
      error: null,
      success: null,
    });

    fetchData(GET_INVESTOR_LIST_QUERY, {
      type: "Investor",
      filters: filterOptions,
    })
      .then((res) => {
        // Display-only rollover of time-based investor statuses; the change is
        // persisted when the full record is opened or saved.
        const filterData = (res.data.getContacts.data || []).map((el) => ({
          ...el,
          status: resolveInvestorStatus(el.status, el.date_of_down_leg),
        }));
        if (filterData.length > 0) {
          this.setState(
            {
              // items: res.data.getCompanies.data,
              // totalCount: res.data.getCompanies.totalCount,
              // error: null,
              // isBusy: null,
              filterData,
              currentIndex: 0,
              data: filterData[0],
              original: { ...filterData[0] },
              error: null,
            },
            () => {
              this.updateURL(filterData[0]);
            }
          );
        } else {
          this.setState({
            filterData: [],
            data: false,
            error:
              "No filtered data found. Please try again with different filters.",
          });
        }
      })
      .catch((error) => {
        this.setState({
          data: false,
          error: error.message || "Unidentified Error",
        });
      });
  }


  updateURL(data) {
    const queryParams = new URLSearchParams(this.props.location.search);
    // const name = queryParams.get("name");
    // const newUrl = `/firm/${data.company_id}${name ? `?name=${name}` : ""}`;
    const newUrl = `/Investor/${data.contact_id}?${queryParams.toString()}`;
    browserHistory.push(newUrl);
  }

  closeDrawer() {
    this.setState({ showDrawer: false, resetDrawer: true });
  }

  toggleDrawer() {
    this.setState((prevState) => ({
      showDrawer: !prevState.showDrawer,
      resetDrawer: false,
    }));
  }
  fetch(id) {
    if (this.client) {
      this.setState({
        // data: null, we have comment this line to avoid loading symbol has ali dont want to be screen get change when value is null we was showing loader 
        error: null,
        success: null,
      });

      if (id === undefined) {
        this.setState({
          data: { contact_type: ["Investor"], status: DEFAULT_INVESTOR_STATUS },
          original: {},
        });
        return;
      }
      Promise.all([
        fetchData(GET_CONTACT_INVESTOR_BY_ID, { contactid: Number(id) }),
        fetchData(GET_PROPERTIES, {
          filters: [
            {
              STATUS: "Off Market",
              SELLER_ID: id,
            },
          ],
        }),
      ])
        .then((res) => {
          // if (res && res.data && res.data.getContactByContactid.contact) {
          //     this.setState({
          //         data: convertDataToForm(res.data.getContactByContactid.contact),
          //         original: { ...convertDataToForm(res.data.getContactByContactid.contact) },
          //         error: null,
          //     });
          // } else {
          //     this.setState({
          //         data: false,
          //         error: res.errors ? res.errors[0].message : "Unidentified Error",
          //     });
          // }
          if (
            res[0] &&
            res[0].data.getContactByContactid.success &&
            res[0].data.getContactByContactid.contact
          ) {
            this.applyAutoStatusChange(res[0].data.getContactByContactid.contact);
          }
          if (
            res[0] &&
            res[0].data.getContactByContactid.success &&
            res[0].data.getContactByContactid.contact &&
            res[1] &&
            Array.isArray(res[1].data.getProperties.properties) &&
            res[1].data.getProperties.properties.length
          ) {
            res[0].data.getContactByContactid.contact['hsc_hot_list'] = res[0].data.getContactByContactid.contact.hsc_id && res[0].data.getContactByContactid.contact.hsc_id.includes(this.state.loggedInUserData.email) ? '1' : '0';

            this.setState({
              data: convertDataToForm(
                res[0].data.getContactByContactid.contact
              ),
              offMarketProperty: convertPropertyDataToForm(
                res[1].data.getProperties.properties
              ),
              original: {
                ...convertDataToForm(res[0].data.getContactByContactid.contact),
              },
              error: null,
            });
          } else if (res[0] && res[0].data.getContactByContactid.success) {
            res[0].data.getContactByContactid.contact['hsc_hot_list'] = res[0].data.getContactByContactid.contact.hsc_id && res[0].data.getContactByContactid.contact.hsc_id.includes(this.state.loggedInUserData.email) ? '1' : '0';
            
            this.setState({
              data: res[0].data.getContactByContactid.contact,
              original: res[0].data.getContactByContactid.contact,
              error: null,
            });
          } else {
            this.setState({
              data: false,
              offMarketProperty: false,
              error: res[0].data.getContactByContactid.message
                ? res[0].data.getContactByContactid.message
                : "Unidentified Error",
            });
          }
        })
        .catch((error) => {
          this.setState({
            data: false,
            error: error.message || "Unidentified Error",
          });
        });
    }
  }
  // Rolls a "1031 Buyer" forward to "ID Period Over" (45 days after the date
  // of down leg) and on to "Passive Investor" (180 days after), updating the
  // fetched contact in place and persisting the new status without touching
  // any other user-facing state (no success banner, no status emails).
  applyAutoStatusChange(contact) {
    const resolvedStatus = resolveInvestorStatus(contact.status, contact.date_of_down_leg);
    if (resolvedStatus === contact.status) return;

    contact.status = resolvedStatus;
    contact.last_modified = new Date().toLocaleDateString("en-US");

    const input = {
      arcimedes_row_id: contact.arcimedes_row_id,
      contact_type: Array.isArray(contact.contact_type)
        ? contact.contact_type
        : typeof contact.contact_type === "string"
        ? contact.contact_type.split(",")
        : ["Investor"],
      contact_id: contact.contact_id ? Number(contact.contact_id) : null,
      cap_rate_max: parseNumber(contact, "cap_rate_max") || null,
      cap_rate_min: parseNumber(contact, "cap_rate_min") || null,
      category: contact.category ? contact.category : null,
      cell_phone: contact.cell_phone ? contact.cell_phone : null,
      company_address: contact.company_address ? contact.company_address : null,
      company_city: contact.company_city ? contact.company_city : null,
      company_name: contact.company_name ? contact.company_name : null,
      company_state: contact.company_state ? contact.company_state : null,
      company_zip: contact.company_zip ? contact.company_zip : null,
      website: contact.website ? contact.website : "",
      deleted: contact.deleted ? contact.deleted : null,
      email: contact.email ? contact.email : null,
      first_name: contact.first_name ? contact.first_name : null,
      hsc_follow_up: contact.hsc_follow_up ? contact.hsc_follow_up : null,
      last_name: contact.last_name ? contact.last_name : null,
      market: contact.market ? contact.market : null,
      multi_tenant_subcategory: contact.multi_tenant_subcategory ? contact.multi_tenant_subcategory : null,
      notes: [],
      phone: contact.phone ? contact.phone : null,
      price_max: parseNumber(contact, "price_max") || null,
      price_min: parseNumber(contact, "price_min") || null,
      profile: contact.profile ? contact.profile : null,
      single_tenant_subcategory: contact.single_tenant_subcategory ? contact.single_tenant_subcategory : null,
      status: resolvedStatus,
      strive_agent: contact.strive_agent ? contact.strive_agent.toString() : null,
      type: contact.type ? contact.type : null,
      agent: contact.agent ? contact.agent : null,
      agent_firm: contact.agent_firm ? contact.agent_firm : null,
      name: contact.contact_type && contact.contact_type.includes("Lender") ? contact.name || "" : "",
      hsc_id: contact.hsc_id ? String(contact.hsc_id) : null,
      date_of_down_leg: contact.date_of_down_leg ? contact.date_of_down_leg : null,
      last_modified: contact.last_modified,
    };

    mutateData(CREATE_OR_UPDATE_CONTACTS_INVESTORS, { input }).catch((error) => {
      console.error("Error persisting automatic investor status change:", error);
    });
  }

  async fetchUserData(client) {
    const token = localStorage.getItem("authToken");
    try {
      const res = await fetchData(GET_BUYER_LIST_QUERY, {
        type: "Investor",
        pageOptions: { page: 1, pageSize: limit },
      });
      if (
        res.data &&
        res.data.getContacts.data &&
        res.data.getContacts.data.length
      ) {
        const isExists = res.data.getContacts.data.some((investor) => {
          const investorFirstName = investor.first_name
            ? investor.first_name.toLowerCase()
            : null;
          const investorLastName = investor.last_name
            ? investor.last_name.toLowerCase()
            : null;
          const stateFirstName = this.state.data.first_name
            ? this.state.data.first_name.toLowerCase()
            : null;
          const stateLastName = this.state.data.last_name
            ? this.state.data.last_name.toLowerCase()
            : null;

          return (
            investorFirstName === stateFirstName &&
            investorLastName === stateLastName &&
            investor.contact_id !== this.state.data.contact_id
          );
        });
        this.setState({ isExists });
        return isExists;
      }

      return false;
    } catch (error) {
      console.error("Error fetching users for duplicate validation:", error);
      return false;
    }
  }
  async handleSubmit(client, e) {
    e.preventDefault();
    this.setState({
      isExists:false,
      typeDuplicate:null
    });
    if (this.state.viewMode) this.setState({ viewMode: false });
   if (this.notesRef.current && this.notesRef.current.validateNotes) {
  const isValid = this.notesRef.current.validateNotes();
  if (!isValid){
      console.log("Stop submit: notes invalid");
     return;
  }
}

    if (!this.state.data.first_name || !this.state.data.last_name) {
      this.setState({ errorTabs: [0], success: null });
      return;
    } else {
      if (this.state.viewMode === true) return;

            this.setState({ errorTabs: [] });
            // const isDuplicate = await this.fetchUserData(client);
            // if (isDuplicate) {
            //     console.log("Duplicate entry detected.");
            //     return;
            // }
            if (!this.props.params.id) {
                const loggedInUserId = this.state.loggedInUserData.id;
                 const loggedInUserEmail = this.state.loggedInUserData.email;
                var pageParams = {
                    page: 1,
                    pageSize: 50
                }
                const offMarketProperty = convertFormToOffMarketData(this.state.offMarketProperty);
                //offMarketProperty.ADDRESS = offMarketProperty.ADDRESS ? formatAddress(offMarketProperty.ADDRESS) : '';
                offMarketProperty.address = offMarketProperty.address ? formatAddress(offMarketProperty.address):"";
                const token = localStorage.getItem('authToken');
                const capRateMax = parseNumber(this.state.data, "cap_rate_max");
                const capRateMin = parseNumber(this.state.data, "cap_rate_min");
                const priceMax = parseNumber(this.state.data, "price_max");
                const priceMin = parseNumber(this.state.data, "price_min");
                if (client) {
                    const input = {
                        // contact_type:"Investor",
                        contact_type: Array.isArray(this.state.data.contact_type)   ? this.state.data.contact_type  : typeof this.state.data.contact_type === "string"  ? this.state.data.contact_type.split(",") : ["Investor"],
                        cap_rate_max: capRateMax ? capRateMax : null ,
                        cap_rate_min: capRateMin ? capRateMin : null,
                        category: this.state.data.category ? this.state.data.category : null,
                        cell_phone: this.state.data.cell_phone ? this.state.data.cell_phone : null,
                        company_address: this.state.data.company_address?  this.state.data.company_address : null,
                        company_city: this.state.data.company_city ? this.state.data.company_city : null,
                        company_name: this.state.data.company_name ? this.state.data.company_name : null,
                        company_state: this.state.data.company_state ? this.state.data.company_state : null,
                        company_zip: this.state.data.company_zip ? this.state.data.company_zip : null,
                        website: this.state.data.website ? this.state.data.website:'' ,
                        deleted: this.state.data.deleted ? this.state.data.deleted : null,
                        email: this.state.data.email ? this.state.data.email : null,
                        first_name: this.state.data.first_name ? this.state.data.first_name : null,
                        hsc_follow_up: this.state.data.hsc_follow_up ? this.state.data.hsc_follow_up : null,
                        //last_modified: this.state.data.last_modified ? this.state.data.last_modified : null,
                        last_name: this.state.data.last_name ? this.state.data.last_name : null,
                        market: this.state.data.market ?  this.state.data.market : null,
                        multi_tenant_subcategory: this.state.data.multi_tenant_subcategory ? this.state.data.multi_tenant_subcategory : null,
                        notes: sanitizeNotesForInput(this.state.data.notes),
                        phone: this.state.data.phone ? this.state.data.phone : null,
                        price_max: priceMax ? priceMax : null,
                        price_min: priceMin ? priceMin : null,
                        profile: this.state.data.profile ? this.state.data.profile : null,
                        single_tenant_subcategory: this.state.data.single_tenant_subcategory ? this.state.data.single_tenant_subcategory : null,
                        status: this.state.data.status ? this.state.data.status : null,
                        strive_agent: this.state.data.strive_agent ? this.state.data.strive_agent.toString() : null,
                        type: this.state.data.type ? this.state.data.type : null,
                        agent: this.state.data.agent ? this.state.data.agent : null,
                        agent_firm: this.state.data.agent_firm ? this.state.data.agent_firm : null,
                        name: this.state.data.contact_type.includes("Lender") ? this.state.data.name || "" : "",
                        hsc_id : this.state.data.hsc_hot_list === '1'? String(loggedInUserEmail) : null,
                        date_of_down_leg: this.state.data.date_of_down_leg ? (dateUStoISO(this.state.data.date_of_down_leg) || this.state.data.date_of_down_leg) : null
                    }
                    try {
                        const res = await mutateData(CREATE_OR_UPDATE_CONTACTS_INVESTORS, { input });
                        const investorData = res.data.createOrUpdateContact.contact;
                        //const contactId = res.data.createOrUpdateContact.contact.contact_id;
                       //const loggedInUserId = String(this.state.loggedInUserData.id);
                      if (investorData && investorData.hsc_id) {
                        const hscIdList = investorData.hsc_id.split(",");
                        investorData.hsc_hot_list = hscIdList.includes(loggedInUserEmail)
                          ? "1"
                          : "0";
                      } else if (investorData) {
                        investorData.hsc_hot_list = "0";
                      }
                        if (res && investorData && investorData.contact_id) {
                            this.setState({
                                data: { ...input },
                                isBusy: false,
                                success: "Saved",
                                viewMode: true,
                                offMarketProperty: offMarketProperty,
                            }, () => {
                                if (!this.props.edit) {
                                    setTimeout(() => {
                                        browserHistory.push({
                                            pathname: `/investor/${investorData.contact_id}`,
                                        });
                                    }, 300);
                                }
                            });
                    
                            window.scrollTo(0, 0);
                        }
                         else if( res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.error && res.data.createOrUpdateContact.error.includes("already exists"))
                          {
                              this.setState({
                                  isExists:true,
                                  typeDuplicate: res.data.createOrUpdateContact.error,
                                viewMode:false})
                          
                        }else {
                            console.error("No contact ID returned from API.");
                        }
                    } catch (error) {
                        console.error("Error in handleSubmit:", error);
                    }
                    
                    
                }

            }
            else {
                this.setState({ viewMode: true }, () => this.saveData(client));
            }
        }
    }
    handleChangeInput (key, value)  {
      this.setState((prevState) => {
          let newValue;

          if (key === "hsc_hot_list") {
              newValue = prevState.data[key] === "1" ? "0" : "1"; // Toggle between "1" and "0"
          } else {
              newValue = value;
          }

          return {
              data: {
                  ...prevState.data,
                  [key]: newValue,
                  
              }
          };
      });
  }
  /* handleChangeInput(key, value) {
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [key]: value,
      },
    }));
  } */

  handleChangeDropdown(query, queryType, x, key, typeKey, reason) {
    const userContactTypes = key === "contact_type" && query.contact_type.split(',').map(type => type.trim());

    if (key === "contact_type" && (userContactTypes.length > 1 || query.contact_type === "Investor") && this.state.typeDuplicate) {
      const match = this.state.typeDuplicate.match(/for\s(.+?)\stype/i); // extract "Agent, Investor, Lender"
      const messageContactTypes = match ? match[1].split(',').map(type => type.trim()) : [];

      const hasMatch = userContactTypes.some(type => messageContactTypes.includes(type));
      if (!hasMatch) {
        this.setState({
          isExists: false,
          typeDuplicate: null,
          isBusy: false
        });
      }
    }
    const data = { ...this.state.data };
    if (key === "status") {
      data.last_modified = new Date().toLocaleDateString("en-US");
      if (query[key] === STATUS_1031_BUYER) {
        // Default the down-leg date to today when 1031 Buyer is picked;
        // the user can still adjust it with the date picker.
        if (this.state.data.status !== STATUS_1031_BUYER || !data.date_of_down_leg) {
          data.date_of_down_leg = dateToString(new Date());
        }
      } else if (!this.props.params.id) {
        // New record that never was a 1031 Buyer - drop the auto-filled date.
        data.date_of_down_leg = null;
      }
      if (!query[key]) {
        data.category = null;
        data.type = null;
        data.single_tenant_subcategory = null;
        data.multi_tenant_subcategory = null;
        data.market = null;
        data.price_min = null;
        data.price_max = null;
        data.cap_rate_min = null;
        data.cap_rate_max = null;
        data.strive_agent = null;
        data.date_of_down_leg = null;
      }
    }
    data[key] = query[key];

    // Keep tenant subcategories in sync with the category/type selection:
    // drop values whose option set is no longer selectable, clear the field
    // entirely when its tenant type is deselected.
    if (key === "category" || key === "type") {
      const types = data.type ? String(data.type).split(",") : [];
      data.single_tenant_subcategory = types.includes("STNL")
        ? pruneTenantSubcategories(data.single_tenant_subcategory, getTenantSubcategoryOptions("STNL", data.category))
        : null;
      data.multi_tenant_subcategory = types.includes("MT")
        ? pruneTenantSubcategories(data.multi_tenant_subcategory, getTenantSubcategoryOptions("MT", data.category))
        : null;
    }

    // When a company is picked from the dropdown, auto-fill the related
    // address details from that company record. A real record has an id or at
    // least the address key from the getCompanies query (arcimedes_row_id can
    // be null), while the fallback option shown for a legacy free-text name
    // has only { name } - skip it so it doesn't wipe manually entered fields.
    const isCompanyRecord =
      reason &&
      typeof reason === "object" &&
      (reason.arcimedes_row_id || reason.company_id || "address" in reason);

    if (queryType === "firm" && isCompanyRecord) {
      data.company_address = reason.address || "";
      data.company_city = reason.city || "";
      data.company_state = stateToAbbr(reason.state);
      data.company_zip = reason.zip ? reason.zip.toString() : "";
      data.website = reason.website || "";
    }

    this.setState({ data });
  }

  async saveData(client) {
    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });
    const offMarketProperty = convertFormToOffMarketData(
      this.state.offMarketProperty
    );
    //offMarketProperty.ADDRESS = offMarketProperty.ADDRESS ? formatAddress(offMarketProperty.ADDRESS) : '';
    offMarketProperty.address = offMarketProperty.address
      ? formatAddress(offMarketProperty.address)
      : "";

    Object.keys(this.state.data).forEach((k) => {
      if (!this.state.data[k] || k === "undefined") {
        const newData = { ...this.state.data };
        delete newData[k];
        this.setState({ data: newData });
      }
    });
    const newData = { ...this.state.data };  
    const loggedInUserId = this.state.loggedInUserData.id;
    const loggedInUserEmail = this.state.loggedInUserData.email;
   if (newData["hsc_hot_list"] === "1") {
    let hotListAgents = [];

    if (newData && newData.hsc_id) {
        hotListAgents = newData.hsc_id
            .split(",")
            .map(id => id.trim()) // Clean any whitespace
            .filter((id, index, self) => id && self.indexOf(id) === index); // Remove duplicates
    }

    if (!hotListAgents.includes(String(loggedInUserEmail))) {
        hotListAgents.push(String(loggedInUserEmail));
    }

    newData.hsc_id = hotListAgents.join(",");
} 
else if (newData["hsc_hot_list"] === "0") {
    if (newData.hsc_id) {
        /* let hotListAgents = newData.hsc_id
            .split(",")
            .map(id => id.trim())
            .filter(id => id && id !== String(loggedInUserEmail)); // Remove current user

        newData.hsc_id = hotListAgents.join(","); */

        const loggedInUserEmailStr = String(loggedInUserEmail);
          let followUpList = newData.hsc_id ? newData.hsc_id.split(",") : [];
          let hotListAgents = followUpList.filter(email => email.trim() !== loggedInUserEmailStr);
          newData.hsc_id = hotListAgents.length > 0 ? hotListAgents.join(",") : "";
    }
}
    var pageParams = {
      page: 1,
      pageSize: 50,
    };

    const capRateMax = parseNumber(this.state.data, "cap_rate_max");
    const capRateMin = parseNumber(this.state.data, "cap_rate_min");
    const priceMax = parseNumber(this.state.data, "price_max");
    const priceMin = parseNumber(this.state.data, "price_min");
    const token = localStorage.getItem("authToken");
    const input = {
      // contact_type:"Investor",
      //added arcimedes_row_id because to handle cancle and undelete or delete button
      arcimedes_row_id: this.state.data.arcimedes_row_id,
      contact_type: Array.isArray(this.state.data.contact_type)
        ? this.state.data.contact_type
        : typeof this.state.data.contact_type === "string"
        ? this.state.data.contact_type.split(",")
        : ["Investor"],
      contact_id: this.props.params.id ? Number(this.props.params.id) : null,
      cap_rate_max: capRateMax ? capRateMax : null,
      cap_rate_min: capRateMin ? capRateMin : null,
      category: this.state.data.category ? this.state.data.category : null,
      cell_phone: this.state.data.cell_phone
        ? this.state.data.cell_phone
        : null,
      company_address: this.state.data.company_address
        ? this.state.data.company_address
        : null,
      company_city: this.state.data.company_city
        ? this.state.data.company_city
        : null,
      company_name: this.state.data.company_name
        ? this.state.data.company_name
        : null,
      company_state: this.state.data.company_state
        ? this.state.data.company_state
        : null,
      company_zip: this.state.data.company_zip
        ? this.state.data.company_zip
        : null,
      website: this.state.data.website ? this.state.data.website:'' ,
      deleted: this.state.data.deleted ? this.state.data.deleted : null,
      email: this.state.data.email ? this.state.data.email : null,
      first_name: this.state.data.first_name
        ? this.state.data.first_name
        : null,
      hsc_follow_up: this.state.data.hsc_follow_up
        ? this.state.data.hsc_follow_up
        : null,
      //last_modified: this.state.data.last_modified ? this.state.data.last_modified : null,
      last_name: this.state.data.last_name ? this.state.data.last_name : null,
      market: this.state.data.market ? this.state.data.market : null,
      multi_tenant_subcategory: this.state.data.multi_tenant_subcategory
        ? this.state.data.multi_tenant_subcategory
        : null,
      notes: sanitizeNotesForInput(this.state.data.notes),
      phone: this.state.data.phone ? this.state.data.phone : null,
      price_max: priceMax ? priceMax : null,
      price_min: priceMin ? priceMin : null,
      profile: this.state.data.profile ? this.state.data.profile : null,
      single_tenant_subcategory: this.state.data.single_tenant_subcategory
        ? this.state.data.single_tenant_subcategory
        : null,
      status: this.state.data.status ? this.state.data.status : null,
      strive_agent: this.state.data.strive_agent
        ? this.state.data.strive_agent.toString()
        : null,
      type: this.state.data.type ? this.state.data.type : null,
      agent: this.state.data.agent ? this.state.data.agent : null,
      agent_firm: this.state.data.agent_firm
        ? this.state.data.agent_firm
        : null,
      name: this.state.data.contact_type.includes("Lender")
        ? this.state.data.name || ""
        : "",
      hsc_id :newData.hsc_id?String(newData.hsc_id):null,
      date_of_down_leg: this.state.data.date_of_down_leg
        ? (dateUStoISO(this.state.data.date_of_down_leg) || this.state.data.date_of_down_leg)
        : null,
    };
    if (
      this.state &&
      this.state.data &&
      this.state.original &&
      this.state.data.last_modified !== undefined &&
      this.state.original.last_modified !== undefined &&
      this.state.data.last_modified !== this.state.original.last_modified
    ) {
      input.last_modified = this.state.data.last_modified;
    }
    try {
      const mutationRes = await mutateData(CREATE_OR_UPDATE_CONTACTS_INVESTORS, { input });

      if( mutationRes && mutationRes.data && mutationRes.data.createOrUpdateContact && mutationRes.data.createOrUpdateContact.error && mutationRes.data.createOrUpdateContact.error.includes("already exists"))
        {
            this.setState({
                isExists:true,
                typeDuplicate: mutationRes.data.createOrUpdateContact.error,
              viewMode:false})
              return
        
      }else if(mutationRes && mutationRes.data && mutationRes.data.createOrUpdateContact && mutationRes.data.createOrUpdateContact.error){
        this.setState({
          isBusy: null,
          error:
          mutationRes && mutationRes.data && mutationRes.data.createOrUpdateContact && mutationRes.data.createOrUpdateContact.error 
              ? mutationRes.data.createOrUpdateContact.error
              : "Unspecified error",
        });
        return
      }

      const investorData = mutationRes.data.createOrUpdateContact.contact;
      const loggedInUserId = String(this.state.loggedInUserData.id);
      const loggedInUserEmail = String(this.state.loggedInUserData.email);
      const hscIdList = (investorData.hsc_id || "").split(",");
      investorData.hsc_hot_list = hscIdList.includes(loggedInUserEmail) ? '1' : '0';
      const teamRes = await fetchData(GET_CONTACT_TEAM_BY_ID, {
          contactid: Number(investorData.contact_id)
      });
  
      const previousStatus = undefined; 
  
      this.setState({
          data: { ...investorData },
          isBusy: false,
          success: "Saved",
          original: mutationRes.data,
          offMarketProperty: offMarketProperty,
      }, () => {
          if (!this.props.edit) {
              browserHistory.push({
                  pathname: `/investor/${investorData.contact_id}`,
              });
          }
      });
      window.scrollTo(0, 0);
  
      const responseDetails = {
          success: true,
          previousStatus,
          status: investorData.status,
          category: capitalizeAll(investorData.category),
          type: formatType(investorData.type),
          market: capitalizeAll(investorData.market),
          tenant_subcategory:
              investorData.type === "MT"
                  ? addSpaceAfterComma(investorData.multi_tenant_subcategory)
                  : investorData.type === "STNL"
                  ? addSpaceAfterComma(investorData.single_tenant_subcategory)
                  : null,
          price_min: investorData.price_min,
          price_max: investorData.price_max,
          cap_rate_min: investorData.cap_rate_min,
          cap_rate_max: investorData.cap_rate_max,
          notes: investorData &&  investorData.notes ? investorData.notes : [],
          strive_agent:  teamRes.data.getTeam && teamRes.data.getTeam.length ? formatName(teamRes.data.getTeam) : null,
          LINK: `${url}Investors?FIRST_NAME=${investorData.first_name}&LAST_NAME=${investorData.last_name}`
      };
  
      if (
        responseDetails.success &&
        responseDetails.status === STATUS_1031_BUYER
      ) {
        sendEmailNotification({ data: responseDetails, type: 'buyer-status-email' })
      }
      if (
        responseDetails.success &&
        !responseDetails.previousStatus &&
        responseDetails.status === STATUS_ACTIVE_INVESTOR
      ) {
        sendEmailNotification({ data: responseDetails, type: 'buyer-status-email' })
      }
      this.setState({
        isBusy: null,
        error: null
      })
  } catch (error) {
      console.error("Error in saveData:", error);
      this.setState({
          isBusy: false,
          data: null,
          error: error.message || "Unspecified error",
          original: null
      });
    }
  }

  render() {
    const data = this.state.data;
    const { edit, isSuper } = this.props;
    const tabsData = [
      {
        name: "Investor",
        renderedComponent: (
          <InvestorInfo
            isExists={this.state.isExists}
            data={data}
            handleChangeInput={this.handleChangeInput}
            handleChangeDropdown={this.handleChangeDropdown}
            viewMode={this.state.viewMode}
            deleted={data && data.deleted === "1"}
            toggleDrawer={this.toggleDrawer}
            handleParentDropdownChange={this.handleChangeDropdown}
                formatDate={(this.state.data && this.state.data.arcimedes_modified) === (this.state.original && this.state.original.arcimedes_modified)}
                typeDuplicate={this.state.typeDuplicate}
          />
        ),
      },
      {
        name: "Investor Company",
        renderedComponent: (
          <InvestorCompanyInfo
            data={data}
            handleChangeInput={this.handleChangeInput}
            handleChangeDropdown={this.handleChangeDropdown}
            viewMode={this.state.viewMode}
            deleted={data && data.deleted === "1"}
          />
        ),
      },
      {
        name: "PEOPLE GROUPS",
        renderedComponent: (
          <PeopleGroupsTab
            data={data}
            viewMode={this.state.viewMode}
            ownerAgentId={this.state.loggedInUserData && this.state.loggedInUserData.id}
          />
        ),
      },
       {
        name: "NOTES",
        renderedComponent: (
          <NotesReusable
          data={data}
            notes={data && data.notes ? data.notes : []}
            contact_id = {data && data.contact_id ? data.contact_id : null}
            viewMode={this.state.viewMode}
            handleChangeInput={this.handleChangeInput}
            ref={this.notesRef}
            //deleted={data && data.DELETED === "1"}
            deleted={data && data.deleted === "1"}
           setState={this.setState.bind(this)}
            onNotesChange={this.handleNotesChange}
            state={this.state}
          />
        ),
      },
      {
        name: "Properties",
        renderedComponent: (
          <InvestorPropertiesTab investorId={this.props.params && this.props.params.id} />
        ),
      },
    ];
    if (data && data.status === "Off-Market" && this.state.offMarketProperty) {
      Object.keys(this.state.offMarketProperty).forEach((e, index) => {
        tabsData.push({
          name: "PROPERTY" + "\n" + (index + 1),
          renderedComponent: this.state.offMarketProperty[e] ? (
            <PropertyInfo
              data={convertFormToOffMarketData(this.state.offMarketProperty[e])}
              handleChangeInput={this.handlePropertyChangeInput}
              handleChangeDropdown={this.handlePropertyChangeDropdown}
              viewMode={this.state.viewMode}
              //deleted={data && data.DELETED === "1"}
              deleted={data && data.deleted === "1"}
              isOffMarket={true}
            />
          ) : (
            <div className="no-results">
              The seller doesn't have any Off Market property.
            </div>
          ),
        });
      });
    }

    return (
      <ApolloConsumer>
        {(client) => {
          if (!this.client) this.client = client;
          return (
            <CRUD
              tabsData={tabsData}
              backLink={`${arc.path.base}contacts/investors`}
              edit={edit}
              state={this.state}
              setState={this.setState.bind(this)}
              handleSubmit={this.handleSubmit.bind(this, client)}
              saveData={() => this.saveData(client)}
              type="investor"
              backName="INVESTORS"
              title={data && `${data.first_name} ${data.last_name}`}
              isSuper={isSuper}
              filterData={this.state.filterData}
              currentIndex={this.state.currentIndex}
              updateURL={this.updateURL}
              // backToUrl={"investors"}
              // Always go to Investors dashboard from the INVESTORS link.
              // (We still keep fromListUrl for other navigation patterns if needed.)
              backToUrl={"/contacts/investors"}
              drawer={
                <Drawer
                  isOpen={this.state.showDrawer}
                  reff={this.drawerComponentRef}
                  closeDrawer={this.closeDrawer}
                >
                  <PropertyDrawer
                    userData={this.props.userData}
                    savedNewItem={this.savedNewItem}
                    closeDrawer={this.closeDrawer}
                    isOffMarket={true}
                    sellerId={this.props.params.id}
                    resetDrawer={this.state.resetDrawer}
                  />
                </Drawer>
              }
            />
          );
        }}
      </ApolloConsumer>
    );
  }
}

